"use client";

import Link from "@introw/ui/link";
import Image from "next/image";
import { useEffect } from "react";
import HouseIcon from "@introw/ui/icons/house";
import { IconButton } from "@introw/ui/buttons/icon-button";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    // captureException(error).catch(() => {});
  }, [error]);

  return (
    <div className="onboarding-layout flex h-screen w-full flex-col items-center overflow-hidden overflow-y-auto bg-white">
      <div className="flex h-screen w-full flex-col items-center justify-center p-6 text-center">
        <Image
          alt="Introw broken"
          width={350}
          height={0}
          quality={100}
          className="mx-auto mb-10 brightness-125 contrast-75"
          src="https://ucarecdn.com/8ee01736-2216-4ddb-a6aa-5bf977a1e180/introwbroken.webp"
        />
        <h1 className="mb-6 text-5xl font-medium">Something went wrong</h1>
        <p className="text-xl text-gray-500">Please don't take it personally!</p>
        <Link href={"/"} className="mt-6 flex w-full items-center justify-center">
          <IconButton Icon={HouseIcon} variant={"outline"}>
            Back to home
          </IconButton>
        </Link>
      </div>
    </div>
  );
}
